"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtistGroup = exports.ArtistGroupRoleValidator = exports.ArtistGroupRoles = void 0;
const toccata_1 = require("@musicaudienceexchange/toccata");
const payments_1 = require("../functions/payments");
const shoutouts_1 = require("./shoutouts");
exports.ArtistGroupRoles = ['artist', 'manager', 'admin'];
let ArtistGroupRoleValidator = class ArtistGroupRoleValidator {
    validate(roles) {
        if (Array.isArray(roles)) {
            return (roles.filter(role => exports.ArtistGroupRoles.indexOf(role) < 0).length === 0);
        }
        return false;
    }
    defaultMessage() {
        return 'Value contains invalid role(s)';
    }
};
ArtistGroupRoleValidator = __decorate([
    toccata_1.validator.ValidatorConstraint({ name: 'ArtistGroupRole', async: false })
], ArtistGroupRoleValidator);
exports.ArtistGroupRoleValidator = ArtistGroupRoleValidator;
class ArtistGroup extends toccata_1.Model {
    constructor() {
        super(...arguments);
        this.members = new Map();
    }
}
__decorate([
    toccata_1.validator.IsString()
], ArtistGroup.prototype, "name", void 0);
__decorate([
    (0, toccata_1.TransformValidateModel)(shoutouts_1.ShoutoutAssets),
    toccata_1.validator.IsOptional()
], ArtistGroup.prototype, "assets", void 0);
__decorate([
    toccata_1.transformer.Transform(({ value }) => {
        // Class transformer is supposed to handle Map types correctly,
        // but it wasn't, so we have to do it manually here...
        if (typeof value === 'object') {
            const map = new Map();
            Object.entries(value || {}).forEach(([key, val]) => {
                map.set(key, val);
            });
            return map;
        }
    }, { toClassOnly: true }),
    toccata_1.validator.IsInstance(Map),
    toccata_1.validator.Validate(ArtistGroupRoleValidator, { each: true })
], ArtistGroup.prototype, "members", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ArtistGroup.prototype, "createdAt", void 0);
__decorate([
    (0, toccata_1.TransformValidateDateTime)()
], ArtistGroup.prototype, "updatedAt", void 0);
__decorate([
    toccata_1.validator.IsString(),
    toccata_1.validator.IsOptional()
], ArtistGroup.prototype, "stripeConnectId", void 0);
__decorate([
    toccata_1.validator.IsIn(payments_1.payments.AccountStatusTypes),
    toccata_1.validator.IsOptional()
], ArtistGroup.prototype, "stripeConnectStatus", void 0);
exports.ArtistGroup = ArtistGroup;
//# sourceMappingURL=artists.js.map